import { Spin } from "antd";

export const PreLoader = () => {
  return (
    <>
      <Spin size="large"></Spin>
    </>
  );
};
